import React, { useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import get from 'lodash/get';
import { updateVulnTemplate } from 'Screens/Contextualization/KnowledgeBase/actions/Actions';
import { selectVulnTemplateDetail, selectVulnTemplateDetailImpacts } from 'store/KnowledgeBase/selectors';
import Impacts from 'Common/Components/Impacts';
import ExpandableWrapper from 'Screens/Contextualization/Manage/components/VulnerabilityDetail/components/Tabs/components/GeneralTab/components/ExpandableWrapper';
import Wrapper from './styled';
import useExpandable from 'Hooks/useExpandable';
import { selectReadOnly } from 'store/Faraday/selectors';

const TAB = 'general';
const ID = 'impact';

const ImpactsTab = () => {
  const dispatch = useDispatch();
  const intl = useIntl();
  const vulnTemplate = useSelector(selectVulnTemplateDetail);
  const id = get(vulnTemplate, '_id', 0);
  const initialValue = useSelector(selectVulnTemplateDetailImpacts);
  const readOnly = useSelector(selectReadOnly);

  const [impacts, setImpacts] = useState(initialValue);

  const getDefaultValue = () => {
    return (
      impacts.accountability ||
      impacts.availability ||
      impacts.integrity ||
      impacts.accountability
    );
  };

  const isExpanded = useExpandable(TAB, ID, getDefaultValue(), id);

  useEffect(() => {
    setImpacts(initialValue);
  }, [initialValue]);

  const onSelectCheckbox = (impactChanged) => {
    const newImpacts = { ...impacts, [impactChanged]: !impacts[impactChanged] };
    setImpacts(newImpacts);
    dispatch(updateVulnTemplate(id, { impact: newImpacts }));
  };

  return (
    <ExpandableWrapper defaultValue={ isExpanded } title={ intl.formatMessage({ id: 'manage.detail.tab.general.impact' }) } tab={ TAB } id={ ID }>
      <Wrapper>
        <Impacts
          selectCheckbox={ onSelectCheckbox }
          hideTitle
          impacts={ impacts }
          disabled={ readOnly }
        />
      </Wrapper>
    </ExpandableWrapper>
  );
};

export default ImpactsTab;
